import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":courseId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "department-course" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [],
});
